export function createSliders() {
  $('.slider .list-images').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    asNavFor: '.slider .list-info .list',
    swipe: true,
    infinite: true,
    arrows: false,
    dots: false,
  });

  $('.slider .list-info .list').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: false,
    arrows: true,
    prevArrow: document.querySelector('.slider .list-info .list__arrow-prev'),
    nextArrow: document.querySelector('.slider .list-info .list__arrow-next'),
    dots: false,
    fade: true,
    infinite: true,
    asNavFor: '.slider .list-images',
    speed: 500,
  });

  document.querySelector('.slider .list-info .list__arrow-prev').addEventListener('click', function () {
    $('.slider .list-info .list').slick('slickPrev');
  })

  document.querySelector('.slider .list-info .list__arrow-prev').addEventListener('click', function () {
    $('.slider .list-info .list').slick('slickNext');
  })
}